import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { PopoverMenu } from '@gem/ui-kit';

import { PopupUserItem } from 'APP/main/Popups/GetParametersManager/components/PopupUserItem/PopupUserItem';
import PopupUserWithMenuItem from 'APP/main/Popups/GetParametersManager/components/PopupUserWithMenuItem';

import { useParticipantListItemPresenter } from './ParticipantListItem.presenter';
import styles from './ParticipantListItem.styles.m.css';
import type { IParticipantListItemParams } from './ParticipantListItem.types';

export const ParticipantListItem: FC<IParticipantListItemParams> = observer((props) => {
  const { participant } = props;

  const presenter = useParticipantListItemPresenter(props);

  if (!presenter.menuItems.length) {
    return (
      <PopupUserItem
        user={participant.user}
        hintClassName={styles.hintWithoutMenu}
        hint={presenter.hint}
        onClick={presenter.onClick}
      />
    );
  }

  return (
    <>
      <PopupUserWithMenuItem
        user={participant.user}
        hint={presenter.hint}
        isOpenedMenu={presenter.isOpenedMenu}
        isMenuLoading={presenter.isMenuLoading}
        toggleMenu={presenter.onToggleMenu}
        onClick={presenter.onClick}
      />

      <PopoverMenu
        isOpened={presenter.isOpenedMenu}
        placement="bottom-end"
        menuItems={presenter.menuItems}
        reference={presenter.menuReference}
        onClose={presenter.onCloseMenu}
      />
    </>
  );
});
